import { useAppDispatch, useAppSelector } from "../../Redux/store"
import { ModalType, setModal } from "../../Redux/uiSlice";
import { HelpModal } from "../Modals/Help";
import { InscribeModal } from "../Modals/Inscribe";
import { InsertGameModal } from "../Modals/InsertGameModal";

export const ModalResolver = () => {
    const modal = useAppSelector(state => state.ui.modal);
    const dispatch = useAppDispatch();

    const onClose = () => dispatch(setModal(undefined));

    switch (modal) {
        case ModalType.INSERTGAME:
            return <InsertGameModal onClose={onClose} />;
        case ModalType.INSCRIBE:
            return <InscribeModal onClose={onClose} />;
        case ModalType.HELP:
            return <HelpModal onClose={onClose} />;
        default:
            return null;
    }
}